import VueApexCharts from 'vue3-apexcharts'

const Boot = ({ app }) => {
  app.use(VueApexCharts)
}

export default Boot
